export const retiredCommonFormats = [
  {
    title: "Common Formats for Event Reporting - Hospital Version 1.1",
    publishMonth: "March",
    publishYear: "2010",
    retiredMonth: "July",
    retiredYear: "2017",
    retireMessage: "Retired with the publication of Hospital Version 2.0"
  },
  {
    title: "Common Formats for Event Reporting - Hospital Version 1.0",
    publishMonth: "September",
    publishYear: "2009",
    retiredMonth: "March",
    retiredYear: "2010",
    retireMessage: "Retired with the publication of Hospital Version 1.1"
  },
]